// extracted by extract-css-chunks-webpack-plugin
module.exports = {"departScheduleItem":"P2bPrPADUfHf"};